var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"fill":"none","height":"28","viewBox":"0 0 40 28","width":"40","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M40 .667H0v26.667h40z","fill":"#0052b4"}}),_c('path',{attrs:{"d":"M15 .666h-5V11.5H0v5h10v10.833h5V16.5h25v-5H15z","fill":"#ffda44"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }